export default __webpack_public_path__ + "static/media/SelectedIcon.4cc869ef.svg";